<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="5" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              placeholder="选择APP分组"
              clearable
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              :disabled="!table.params.platid"
              filterable
              placeholder="选择APP盘口"
              clearable
              @on-change="smart"
            >
              <Option
                v-for="(item, index) in app_list.filter(
                  item => item.platform == table.params.platid
                )"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 140px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              :disabled="!table.params.platid || !table.params.app_id"
              placeholder="玩家ID"
              clearable
            />
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">风控类型:</span>
            <Select
              v-model="table.params.smart_id"
              filterable
              placeholder="选择风控类型"
              clearable
            >
              <Option
                v-for="(item, index) in select.smart_list"
                :value="item.smart_id"
                :label="item.smart_name"
                :key="index"
                >{{ item.smart_name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">货币分类:</span>
            <Select
                v-model="table.params.currency_type"
                filterable
                placeholder="选择货币分类"
                clearable
            >
              <Option
                  v-for="item in currencyList"
                  :value="item.currency"
                  :label="item.name"
                  :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

      </Row>

      <Row :gutter="24" style="margin-top: 20px">
        <Col span="5"
        ><label style="display: flex; align-items: center">
          <span style="width: 120px">筛选时间:</span>
          <DatePicker
              type="date"
              v-model="select.dataTime"
              placement="bottom-end"
              placeholder="筛选时间"
              style="width: 100%"
          ></DatePicker>
        </label>
        </Col>
        <Col span="1">
          <Button
              type="primary"
              :size="isMOble() ? 'small' : 'default'"
              @click="getUserRiskList(1)"
              :disabled="!table.params.platid || !table.params.app_id"
          >查询</Button
          >
        </Col>
      </Row>

      <Row style="margin-top: 10px">
        <Col span="10">
          <span
            >投注金额:{{ (table.res.bet / 10000).toFixed(2) }}&nbsp;&nbsp;</span
          >
          <span style="margin-left: 10px"
            >返奖金额:{{ (table.res.hit / 10000).toFixed(2) }}&nbsp;&nbsp;</span
          >
          <span style="margin-left: 10px"
            >返奖-投注:{{ (table.res.win / 10000).toFixed(2) }}</span
          >
          <span style="margin-left: 10px"
            >人均盈亏:{{
              table.res.user_sum == 0
                ? 0
                : (table.res.win / 10000 / table.res.user_sum).toFixed(2)
            }}</span
          >
          <span style="margin-left: 10px"
            >扶持人数:{{ table.res.user_sum }}</span
          >
        </Col>
        <Col span="10" style="float: right; text-align: right">
          <Button
            @click="serchGetExcelList(1008)"
            style="margin-left: 10px"
            :disabled="!table.params.platid || !table.params.app_id"
            type="info"
            >导出策略用户数据</Button
          >
          <Button
            @click="serchGetExcelList(1006)"
            style="margin-left: 10px"
            :disabled="!table.params.platid || !table.params.app_id"
            type="info"
            >导出当前筛选信息</Button
          >
          <Button
            type="info"
            style="margin-left: 10px"
            :size="isMOble() ? 'small' : 'default'"
            @click="getUserSmartCount"
            :disabled="!table.params.platid || !table.params.app_id"
            >执行玩家人次</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 10px"
      :max-height="350"
      @on-column-width-resize="widthResize"
    ></Table>
    <Page
      v-show="table.data.length"
      style="margin-top: 10px"
      :current="table.params.page"
      :total="table.total"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      show-sizer
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <!-- 执行玩家人数与执行金额 -->
    <Modal v-model="modal3.show" width="550" footer-hide>
      <div slot="header" style="text-align: center">执行玩家人次</div>
      <div style="text-align: right; margin-bottom: 10px">
        策略执行人次：{{ modal3.countTotal }}
      </div>
      <Table border :columns="modal3.columns" :data="modal3.data"></Table>
    </Modal>

    <!-- 策略执行详情 -->
    <Modal v-model="modal1.show" :width="isMOble() ? '600' : '700'" footer-hide>
      <div slot="header" style="text-align: center">策略执行详情</div>
      <Row :gutter="16" style="margin-bottom: 10px">
        <Col span="6">
          <Button @click="serchGetExcelList(1007)" type="primary"
            >导出当前信息</Button
          >
        </Col>
        <Col span="6" offset="16" style="text-align: right">
          <span>策略执行次数：{{ modal1.total }}</span>
        </Col>
      </Row>
      <Table border :columns="modal1.columns" :data="modal1.data"></Table>
      <Page
        v-show="modal1.data.length"
        style="margin-top: 10px"
        :current="modal1.params.page"
        :total="modal1.total"
        :page-size-opts="modal1.params.pageSizes"
        :page-size="modal1.params.limit"
        @on-change="smartPage"
        >></Page
      >
    </Modal>

    <!-- 历史数据 -->
    <Modal v-model="modal2.show" width="600" footer-hide>
      <div slot="header" style="text-align: center">历史数据</div>
      <Table border :columns="modal2.columns" :data="modal2.data"></Table>
    </Modal>
    <!-- 导表模块 -->
    <Modal v-model="Excel.show" width="700">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ Excel.title }}</span>
      </p>
      <Row :gutter="16">
        <Col span="5" v-if="Excel.excelType == 1008">
          <Select v-model="Excel.smart_id" clearable placeholder="最后执行策略">
            <Option
              v-for="item in select.smart_list"
              :key="item.smart_id"
              :label="item.smart_name"
              :value="item.smart_id"
              >{{ item.smart_name }}</Option
            >
          </Select>
        </Col>
        <Col span="9" v-if="Excel.excelType == 1008">
          <DatePicker
            class="DatePickerIview"
            :options="dateOptions"
            :clearable="false"
            type="daterange"
            format="yyyy-MM-dd"
            v-model="Excel.time"
            placement="bottom-end"
            placeholder="筛选时间"
          ></DatePicker>
        </Col>
        <Col span="5">
          <Input v-model="Excel.desc" placeholder="备注" clearable></Input>
        </Col>
        <Col span="3">
          <Button type="primary" @click="createdExcel">导出excel</Button>
        </Col>
      </Row>
      <Table
        border
        style="margin-top: 10px"
        :columns="Excel.excelType == 1007 ? Excel.columns2 : Excel.columns"
        :data="Excel.data"
      ></Table>
      <Page
        style="margin-top: 10px"
        :total="Excel.total"
        :current="Excel.currentPage"
        :page-size-opts="Excel.pageSizes"
        :page-size="Excel.limit"
        show-sizer
        @on-page-size-change="excelchange"
        @on-change="excelcurrentPage"
      ></Page>
    </Modal>
  </div>
</template>
<script>
import { TransTopReq, GetAllGameList } from "@/api/admin/risk";
import moment from "moment";
import { getTableSetting, setTableSetting } from "@/libs/util";
import { tableSettingModel } from "@/libs/config";
import { GetToken } from "@/libs/util";
import {mapState} from "vuex";

export default {
  name: "userSupport",
  data() {
    const userName = GetToken().username;

    return {
      tableSetting: {},
      select: {
        smart_list: [],
        game_list: [],
        dataTime: moment().format("YYYY-MM-DD")
      },
      //表单数据
      table: {
        params: {
          platid: 0,
          app_id: 0,
          smart_id: 0,
          s_time: 0,
          e_time: 0,
          page: 1,
          limit: 10,
          user_id: "",
          pack_no: -1,
          game_id: 0,
          is_online: 0,
          currency_type: ''
        },
        res: {
          bet: 0,
          hit: 0,
          win: 0,
          user_sum: 0
        },
        data: [],
        columns: [
          { type: "index", title: "序号", width: 50, align: "center" },
          {
            key: "user_id",
            title: "玩家ID",
            align: "center",
            width: 80,
            resizable: true
          },
          {
            key: "user_name",
            title: "玩家昵称",
            align: "center",
            width: 80,
            resizable: true
          },
          {
            key: "general",
            title: "所属商户",
            align: "center",
            width: 80,
            resizable: true,
            render: (h, params) => {
              return h("span", `${params.row.general_name}(${params.row.general})`);
            }
          },
          {
            key: "pack_name",
            title: "所属子商户",
            align: "center",
            width: 100,
            resizable: true,
            render: (h, params) => {
              if (!params.row.pack_no && params.row.pack_name == "官方子商户") {
                params.row.pack_no = 0;
              }
              let str =
                params.row.pack_no || params.row.pack_no == 0
                  ? `(${params.row.pack_no})`
                  : "";
              return h("span", `${params.row.pack_name}${str}`);
            }
          },
          {
            key: "currency_type",
            title: "货币分类",
            align: "center",
            width: 80,
            resizable: true
          },
          {
            key: "is_online",
            title: "是否在线",
            align: "center",
            width: 100,
            resizable: true,
            render: (h, params) =>
              h(
                "span",
                {
                  style: {
                    color: params.row.is_online == 1 ? "#32CD32" : "red"
                  }
                },
                params.row.is_online == 1 ? "在线" : "离线"
              )
          },
          // {
          //   key: "pay_sum",
          //   title: "转入金额",
          //   align: "center",
          //   width: 100,
          //   resizable: true,
          //   render: (h, params) =>
          //     h("span", (params.row.pay_sum / 10000).toFixed(2))
          // },
          {
            key: "bet_sum",
            title: "投注金额",
            align: "center",
            width: 100,
            resizable: true,
            render: (h, params) =>
              h("span", (params.row.bet_sum / 10000).toFixed(2))
          },
          {
            key: "loss_sum",
            title: "盈亏金额",
            align: "center",
            width: 100,
            resizable: true,
            render: (h, params) =>
              h("span", (params.row.loss_sum / 10000).toFixed(2))
          },
          // {
          //   key: "today_win_pay_rate",
          //   title: "当日盈亏转入比",
          //   align: "center",
          //   width: 100,
          //   resizable: true,
          //   render: (h, params) =>
          //     h("span", params.row.today_win_pay_rate.toFixed(2) + "%")
          // },
          // {
          //   key: "three_win_pay_rate",
          //   title: "近三日盈亏转入比",
          //   align: "center",
          //   width: 110,
          //   resizable: true,
          //   render: (h, params) =>
          //     h("span", params.row.three_win_pay_rate.toFixed(2) + "%")
          // },
          {
            key: "loss_bet_rate",
            title: "盈亏比例",
            align: "center",
            width: 100,
            resizable: true,
            render: (h, params) =>
              h("span", params.row.loss_bet_rate.toFixed(2) + "%")
          },
          {
            title: "历史数据",
            align: "center",
            width: 100,
            key: "history_data",
            resizable: true,
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {
                    props: { type: "primary" },
                    style: { color: "#57a3f3", cursor: "pointer" },
                    on: {
                      click: () => {
                        this.modal2.data = [];
                        this.modal2.data.push(params.row);
                        this.modal2.show = true;
                      }
                    }
                  },
                  "点击查询"
                )
              ]);
            }
          },

          {
            key: "register_time",
            title: "注册时间",
            width: 100,
            resizable: true,
            align: "center"
          },
          {
            key: "last_login_time",
            title: "最后登录时间",
            width: 100,
            resizable: true,
            align: "center"
          },
          {
            key: "exec_time",
            title: "最后执行时间",
            width: 100,
            resizable: true,
            align: "center"
          },
          {
            key: "last_login_ip",
            title: "最后登录IP",
            align: "center",
            width: 100,
            resizable: true
          },
          {
            key: "smart_name",
            title: "最后执行策略",
            align: "center",
            width: 100,
            resizable: true
          },
          {
            title: "策略执行详情",
            align: "center",
            width: 120,
            key: "option",
            fixed: this.isMOble() ? "" : "right",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: { type: "primary" },
                    style: { margin: "2px", padding: "3px 8px" },
                    on: {
                      click: () => {
                        this.modal1.params.user_id = params.row.user_id;
                        this.getUserSmartInfos(1);
                        this.modal1.show = true;
                      }
                    }
                  },
                  "查看详情"
                )
              ]);
            }
          }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40]
      },
      //查看详情
      modal1: {
        show: false,
        data: [],
        params: { limit: 10, page: 1, user_id: 0 },
        total: 0,
        columns: [
          { type: "index", title: "序号", width: 50, align: "center" },
          {
            key: "gid",
            title: "执行游戏",
            align: "center",
            render: (h, params) => {
              let find = this.select.game_list.find(
                item => item.game_id == params.row.gid
              );
              return h("div", [
                h("span", find.game_name),
                h(
                  "span",
                  { style: "color:#bbb" },
                  params.row.glv ? `（${params.row.glv}）` : ""
                )
              ]);
            }
          },
          {
            key: "bet",
            title: "投注金额",
            align: "center",
            render: (h, params) =>
              h("span", (params.row.bet / 10000).toFixed(2))
          },
          {
            key: "win",
            title: "盈亏金额",
            align: "center",
            render: (h, params) =>
              h("span", (params.row.win / 10000).toFixed(2))
          },
          { key: "name", title: "被执行策略", align: "center" },
          { key: "itime", title: "执行时间", align: "center" }
        ]
      },
      //历史数据
      modal2: {
        show: false,
        data: [],
        param: {},
        columns: [
          { type: "index", title: "序号", width: 50, align: "center" },
          {
            key: "h_bet_point",
            title: "历史投注金额",
            align: "center",
            render: (h, params) =>
              h("span", (params.row.h_bet_point / 10000).toFixed(2))
          },
          {
            key: "h_loss_point",
            title: "历史盈亏金额",
            align: "center",
            render: (h, params) =>
              h("span", (params.row.h_loss_point / 10000).toFixed(2))
          },
          {
            key: "h_pay_point",
            title: "历史转入金额",
            align: "center",
            render: (h, params) =>
              h("span", (params.row.h_pay_point / 10000).toFixed(2))
          },
          {
            key: "h_win_rate",
            title: "历史盈亏比例",
            align: "center",
            render: (h, params) =>
              h("span", params.row.h_win_rate.toFixed(2) + "%")
          },
          {
            key: "h_win_rate",
            title: "历史盈亏转入比",
            align: "center",
            render: (h, params) => {
              if (params.row.h_pay_point == 0) {
                return h("span", "0.00%");
              } else {
                return h(
                  "span",
                  (
                    (params.row.h_loss_point / params.row.h_pay_point) *
                    100
                  ).toFixed(2) + "%"
                );
              }
            }
          }
        ]
      },
      //执行金额执行人数
      modal3: {
        show: false,
        data: [],
        param: {},
        countTotal: 0,
        columns: [
          { type: "index", title: "序号", width: 50, align: "center" },
          {
            key: "smart_id",
            title: "执行策略名称",
            align: "center",
            render: (h, params) => {
              let find = this.select.smart_list.find(
                el => el.smart_id == params.row.smart_id
              );
              return h("span", find ? find.smart_name : "");
            }
          },
          { key: "count", title: "执行玩家人次", align: "center" },
          {
            key: "bet",
            title: "投注金额",
            align: "center",
            render: (h, params) => {
              return h("span", (params.row.bet / 10000).toFixed(2));
            }
          },
          {
            key: "",
            title: "盈亏金额",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                ((params.row.hit - params.row.bet) / 10000).toFixed(2)
              );
            }
          }
        ]
      },
      //导出
      Excel: {
        show: false,
        rdataTime: [
          new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 3600 * 1000),
          this.getCurrentZeroDay()
        ],
        ldataTime: [],
        time: [this.getCurrentZeroDay(), new Date(new Date())],
        desc: "",
        pack_no: "",
        data: [],
        excelType: 1,
        title: "",
        columns: [
          { key: "create_time", title: "导出数据时间", align: "center" },
          // { key: 'user_id', title: '操作人', align: 'center' },
          {
            key: "user_id",
            title: "操作人",
            align: "center",
            render: (h) => {
              return h(
                "span",
                userName
              );
            }
          },

          { key: "desc", title: "备注", align: "center" },
          {
            key: "pack_no",
            title: "操作状态",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      disabled: params.row.status ? false : true
                    },
                    style: { margin: "2px", padding: "3px 8px" },
                    on: {
                      click: () => {
                        let params1 = {
                          id: params.row.id,
                          app_id: this.table.params.app_id
                        };
                        this.downLoadFile(params1);
                      }
                    }
                  },
                  params.row.status ? "下载数据表" : "等待完成"
                ),
                h(
                  "Button",
                  {
                    props: { type: "error" },
                    style: { margin: "2px", padding: "3px 8px" },
                    on: {
                      click: () => {
                        this.removemsg(params.row.id);
                      }
                    }
                  },
                  "删除记录"
                )
              ]);
            }
          }
        ],
        columns2: [
          { key: "create_time", title: "导出数据时间", align: "center" },
          { key: "player_id", title: "导出玩家ID", align: "center" },
          { key: "user_id", title: "操作人", align: "center" },
          { key: "desc", title: "备注", align: "center" },
          {
            key: "pack_no",
            title: "操作状态",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      disabled: params.row.status ? false : true
                    },
                    style: { margin: "2px", padding: "3px 8px" },
                    on: {
                      click: () => {
                        let params1 = {
                          id: params.row.id,
                          app_id: this.table.params.app_id
                        };
                        this.downLoadFile(params1);
                      }
                    }
                  },
                  params.row.status ? "下载数据表" : "等待完成"
                ),
                h(
                  "Button",
                  {
                    props: { type: "error" },
                    style: { margin: "2px", padding: "3px 8px" },
                    on: {
                      click: () => {
                        this.removemsg(params.row.id);
                      }
                    }
                  },
                  "删除记录"
                )
              ]);
            }
          }
        ],
        total: 0,
        limit: 10,
        pageSizes: [10, 20, 30, 40],
        currentPage: 1,
        is_pid: "",
        smart_id: ""
      }
    };
  },
  computed: {
    ...mapState({
      currencyList: state => state.app.globalCurrencyList
    }),
  },
  methods: {
    //分页
    excelchange(limit) {
      this.Excel.currentPage = 1;
      this.Excel.limit = limit;
      this.GetExcelList(this.Excel.excelType);
    },
    //分条
    excelcurrentPage(page) {
      this.Excel.currentPage = page;
      this.GetExcelList(this.Excel.excelType);
    },
    //获取执行策略
    GetSmartList() {
      let { platid, app_id } = this.table.params;
      let _param1 = this.getTransParams("GetSmartRiskGroup", {
        platid,
        app_id
      });
      TransTopReq(_param1).then(res => {
        this.select.smart_list = res["_param"].data || [];
      });
    },
    returnParam(func) {
      return {
        mod: "root",
        platid: this.table.params.platid,
        app_id: this.table.params.app_id,
        param: {
          _mod: "manager",
          _func: func,
          _param: {
            ...this.table.params,
            s_time: new Date(this.select.dataTime).getTime() / 1000,
            e_time: Math.floor(
              new Date(
                new Date(this.select.dataTime).setHours(23, 59, 59, 59)
              ).getTime() / 1000
            ),
            user_id: Number(this.table.params.user_id)
          }
        }
      };
    },
    downLoadFile(params) {
      TransTopReq(this.returnParamExcel("DownloadTickFile", params)).then(
        res => {
          const content = res._param.data;
          const url = res._param.url;
          if (url) {
            //下载xlsl
            this.downloadexcel(url, "转出订单数据");
          } else {
            const blob = new Blob([content]);
            const fileName = res._param.name;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        }
      );
    },
    //获取列表
    getUserRiskList(num) {
      if (num) this.table.params.page = 1;
      // TransTopReq()
      TransTopReq(this.returnParam("GetUserSmartRisk")).then(res => {
        this.table.data = res["_param"].data || [];
        this.table.total = res["_param"].total;
      });
      TransTopReq(this.returnParam("GetUserSmartRiskProfit")).then(res => {
        this.table.res = res["_param"];
      });
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page;
      this.getUserRiskList();
    },
    getAllGameList() {
      let param = { gtype: 0, page: 1, page_size: 10000 };
      GetAllGameList(param).then(res => {
        this.select.game_list = res._param.data || [];
      });
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1;
      this.table.params.limit = limit;
      this.getUserRiskList();
    },
    getTransParams(_func, _params, from) {
      let { platid, app_id } = from || _params;
      return {
        mod: "root",
        platid,
        app_id,
        param: {
          _mod: "manager",
          _func,
          _param: { ..._params }
        }
      };
    },

    getUserSmartCount() {
      this.modal3.show = true;
      let { platid, app_id } = this.table.params;
      let _param = this.getTransParams("GetUserSmartCount", {
        platid,
        app_id,
        s_time: new Date(this.select.dataTime).getTime() / 1000,
        e_time: Math.floor(
          new Date(
            new Date(this.select.dataTime).setHours(23, 59, 59, 59)
          ).getTime() / 1000
        )
      });

      TransTopReq(_param).then(res => {
        this.modal3.data = res["_param"].data || [];
        this.modal3.countTotal = this.modal3.data.reduce((res, cur) => {
          res += cur.count;
          return res;
        }, 0);
      });
    },
    getUserSmartInfos(num) {
      if (num) this.modal1.params.page = 1;
      let { platid, app_id } = this.table.params;
      let _param = this.getTransParams("GetUserSmartInfos", {
        ...this.modal1.params,
        s_time: new Date(this.select.dataTime).getTime() / 1000,
        e_time: Math.floor(
          new Date(
            new Date(this.select.dataTime).setHours(23, 59, 59, 59)
          ).getTime() / 1000
        ),
        app_id,
        platid
      });

      TransTopReq(_param).then(res => {
        this.modal1.data = res._param.data || [];
        this.modal1.total = res._param.total;
      });
    },
    smartPage(page) {
      this.modal1.params.page = page;
      this.getUserSmartInfos();
    },
    smart(data) {
      if (data) this.GetSmartList();
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId();
      this.table.params.app_id = this.app_list.find(
        item => item.platform == this.table.params.platid
      ).appid;
      this.GetSmartList();
    },
    serchGetExcelList(typenum) {
      this.Excel.desc = "";
      this.Excel.currentPage = 1;
      this.GetExcelList(typenum);
    },
    //获取导表列表
    GetExcelList(typenum) {
      this.Excel.show = true;
      this.Excel.excelType = typenum;
      if (typenum == 1006) {
        this.Excel.title = "扶持玩家列表导出";
      } else if (typenum == 1007) {
        this.Excel.title = "策略执行详情导出";
      } else if (typenum == 1008) {
        this.Excel.title = "策略用户数据";
      }
      let param = {
        app_id: this.table.params.app_id,
        user_id: 0,
        type: this.Excel.excelType,
        status: -1,
        page: this.Excel.currentPage,
        limit: this.Excel.limit
      };
      TransTopReq(this.returnParamExcel("NewGetTickList", param)).then(res => {
        let data = res._param.list;
        if (this.Excel.excelType == 1007) {
          data.map(item => {
            item["player_id"] = JSON.parse(item.data).user_id;
          });
        }
        this.Excel.data = data;
        this.Excel.total = res._param.total;
      });
    },
    //创建导表
    createdExcel() {
      // let num = (Timestamp(this.Excel.rdataTime[1]) / 1000 - Timestamp(this.Excel.rdataTime[0]) / 1000) / 86400
      // if (num > 30) {
      //     return this.$Message.error('注册时间跨度不能超过30天')
      // }
      let data = {};
      if (this.Excel.excelType == 1006) {
        data = {
          user_id: Number(this.table.params.user_id),
          pack_no: -1,
          is_online: 0,
          game_id: 0,
          smart_id: Number(this.table.params.smart_id),
          s_time:
            this.select.dataTime == null
              ? 0
              : moment(
                  moment(this.select.dataTime).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() / 1000,
          e_time:
            this.select.dataTime == null
              ? 0
              : moment(
                  moment(this.select.dataTime).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() /
                  1000 +
                86399
        };
      } else if (this.Excel.excelType == 1007) {
        data = {
          user_id: this.modal1.params.user_id,
          s_time:
            this.select.dataTime == null
              ? 0
              : moment(
                  moment(this.select.dataTime).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() / 1000,
          e_time:
            this.select.dataTime == null
              ? 0
              : moment(
                  moment(this.select.dataTime).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() /
                  1000 +
                86399
        };
      } else if (this.Excel.excelType == 1008) {
        data = {
          app_id: this.table.params.app_id,
          smart_id: Number(this.Excel.smart_id),
          stime:
            this.Excel.time == null
              ? 0
              : moment(
                  moment(this.Excel.time[0]).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() / 1000,
          etime:
            this.Excel.time == null
              ? 0
              : moment(
                  moment(this.Excel.time[1]).format("YYYY-MM-DD HH:mm:ss")
                ).valueOf() /
                  1000 +
                86399
        };
      }
      let param = {
        app_id: this.table.params.app_id,
        type: this.Excel.excelType,
        desc: this.Excel.desc,
        data: JSON.stringify(data)
      };
      TransTopReq(this.returnParamExcel("NewCreateTick", param)).then(res => {
        this.$Message.success("创建成功，请稍候下载");
        this.GetExcelList(this.Excel.excelType);
      });
    },
    //下载excel
    downloadexcel(data, name) {
      if (!data) return;
      let aTag = document.createElement("a");
      aTag.href = data;
      aTag.download = data;
      aTag.click();
    },
    //删除导表数据
    DelTickexcel(id) {
      let param = { app_id: this.table.params.app_id, id };
      TransTopReq(this.returnParamExcel("NewDelTick", param)).then(res => {
        this.$Message.success("删除成功");
        this.GetExcelList(this.Excel.excelType);
      });
    },
    //删除导表数据弹窗
    removemsg(id) {
      this.$Modal.confirm({
        title: "删除记录",
        content: "<p>是否从后台列表中删除本条导出记录?, 是否继续?</p>",
        onOk: () => {
          this.DelTickexcel(id);
        }
      });
    },
    returnParamExcel(func, params) {
      return {
        mod: "root",
        platid: this.table.params.platid,
        app_id: this.table.params.app_id,
        param: {
          _mod: "manager",
          _func: func,
          _param: { ...params }
        }
      };
    },
    widthResize(val1, val2, val3) {
      this.tableSetting[val3.key] = val1;
      setTableSetting(tableSettingModel.userList, this.tableSetting);
    },
    initTableSetting() {
      this.tableSetting = getTableSetting(tableSettingModel.userList);
      this.table.columns.forEach(element => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key];
        }
      });
    }
  },

  created() {
    this.initTableSetting();
    this.initFunc();
    this.getAllGameList();
    //获取扶持列表
  }
};
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}

/deep/ .ivu-date-picker {
  min-width: 200px;
}
</style>
